export default __webpack_public_path__ + "static/media/img-player-play.2c561d05.png";